// src/hooks/useKiddoStars.ts
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Path } from '../constants/Path';
import { getActiveList, getUserData } from '../views/auth/slice/selectors';

// Gwiazdki gier Easy. Na razie pamięta je przeglądarka: przy każdym koncie i liście — które gry z kolejki 1–9 są
// ukończone i kiedy po raz pierwszy (data ISO), więc na innym urządzeniu rząd jest pusty. Czyta je i zapisuje tylko
// ten plik — przy monitoringu aktywności dane przejdą na serwer i zmieni się tylko on.
const STORAGE_KEY = 'kiddoStars';

type StoredStars = Record<string, Record<string, Partial<Record<Path, string>>>>;

const readStars = (): StoredStars => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {};
  } catch {
    return {};
  }
};

// Zapisuje gwiazdkę ukończonej gry na aktywnej liście — o ile dziecko ją zdobyło (earns; przy pomijaniu słów nie).
// Zwraca gry, które miały gwiazdkę już przed tym ukończeniem — ekran końca gry zaczyna od tego stanu, a gwiazdkę tej
// gry zapala dopiero na oczach dziecka. Gwiazdek nie ubywa: pełny rząd zostaje na stałe, a ponowne ukończenie gry
// niczego nie zmienia.
const useKiddoStars = (game: Path, earns: boolean): Path[] => {
  const userId = useSelector(getUserData)?.id;
  const listId = useSelector(getActiveList)?.id;
  const [earnedBefore] = useState(() => Object.keys(readStars()[userId]?.[listId] ?? {}) as Path[]);

  useEffect(() => {
    if (!earns || !userId || !listId) return;

    const stars = readStars();
    const listStars = stars[userId]?.[listId] ?? {};

    if (listStars[game]) return;

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        ...stars,
        [userId]: { ...stars[userId], [listId]: { ...listStars, [game]: new Date().toISOString() } },
      }));
    } catch { /* pamięć przeglądarki pełna albo zablokowana — gwiazdka świeci tylko na tym ekranie */ }
  }, [earns, game, userId, listId]);

  return earnedBefore;
};

export default useKiddoStars;
